export default "__VITE_ASSET__DcDoUM0l__"